import{CheckboxStateEnum as e}from"../MixedCheckbox.js";const o=o=>[e.all,e.mixed].includes(o);export{o as isChecked};
